import { useCallback } from 'react';

import Icon from '@publicImages/svg/circle-arrow.svg?icon';

import type { TPromoBannerMarqueeProps, TWithOnClick } from '@/features/promoBanners/types';

import MarqueeBannerContainer from '@/components/MarqueeBanner/Container';

import Eyebrow from '../Eyebrow';

import styles from './PromoBannerMarquee.module.scss';

const PromoBannerMarquee = ({ description, eyebrow, onClick, title, url }: TWithOnClick<TPromoBannerMarqueeProps>) => {
  const hasEyebrow = !!eyebrow;
  const hasTitle = !!title;
  const hasDescription = !!description;
  const hasContent = hasEyebrow || hasTitle || hasDescription;

  const clickCb = useCallback(() => {
    onClick?.({ label: (title || description || eyebrow?.tag || eyebrow?.text)!, url: url! });
  }, [description, eyebrow, onClick, title, url]);

  return (
    <>
      <MarqueeBannerContainer className={styles.root} onClick={clickCb} url={url}>
        {hasContent && (
          <div className={styles.content}>
            {hasEyebrow && <Eyebrow className={styles.eyebrow} {...eyebrow} isOmitPastCountdown />}
            {hasTitle && <div className={styles.title}>{title}</div>}
            {hasTitle && hasDescription && '|'}
            {hasDescription && <div className={styles.description}>{description}</div>}
            {url && <Icon className={styles.icon} />}
          </div>
        )}
      </MarqueeBannerContainer>
      <div className={styles.heightPlaceholder} />
    </>
  );
};

export default PromoBannerMarquee;
